export const FUMES_VERSION = "3.0.0+406"; 
